<div class="min-w-screen flex h-screen flex-col md:flex-row">
  <app-sidebar />

  <main class="flex flex-1 w-full flex-col overflow-x-auto px-6 pt-6 md:px-12 md:pt-10 bg-contain bg-no-repeat bg-bottom" style="background-image: url('/assets/images/wave.svg');" >
    <app-alerts />

    <router-outlet />
  </main>
</div>
